export default "__VITE_ASSET__7a835133__"